import { render } from "./ExpensesToolbar.vue?vue&type=template&id=2f67f352"
import script from "./ExpensesToolbar.vue?vue&type=script&lang=js"
export * from "./ExpensesToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__